export const navbarReady = () => { 
  // Intialize Slide Menu
  if (document.querySelector('.nav-icon-desktop')) {
    document.querySelector('.nav-icon-desktop').addEventListener('click', toggleNavbar);
  }
  if (document.querySelector('.nav-icon-mobile')) {
    document.querySelector('.nav-icon-mobile').addEventListener('click', toggleNavbar);
  }
  
  // Close Menu + Backdrop click close menu
  if (document.querySelector('.nav-menu-close')) {
    document.querySelector('.nav-menu-close').addEventListener('click', toggleNavbar);
  }
  if (document.querySelector('.nav-menu-close-backdrop')) {
    document.querySelector('.nav-menu-close-backdrop').addEventListener('click', toggleNavbar);
  }

  // Close Menu when ESC is pressed
  document.addEventListener('keydown', function(event){
    if(event.key === "Escape" && !document.querySelector('#nav-menu').classList.contains('nav-toggle')){
      toggleNavbar();
    }
  });
};

const toggleNavbar = () => {
  document.querySelector('#nav-menu').classList.toggle('nav-toggle');
  document.querySelector('#nav-toggle-backdrop').classList.toggle('nav-toggle');
};


// Payment links modal
export const paymentLinksReady = () => {
  if (document.querySelector('[data-popup="payment"]')) {
    document.querySelector('[data-popup="payment"]').addEventListener('click', togglePayments);
    document.querySelector('#payment-wrapper').addEventListener('click', togglePayments);
    document.querySelector('#close-payment-popup').addEventListener('click', togglePayments);
    document.querySelector('.payment-popup').addEventListener('click', (e) => { e.stopPropagation()});
  }
}

const togglePayments = (e) => {
  e.preventDefault();
  console.log('toggle payments');
  document.querySelector('#payment-wrapper').classList.toggle('payments-toggle');
}